// extracted by mini-css-extract-plugin
module.exports = {"card":"_335eqpo483iOgPFlpoipYL","no-padding":"_11fqcf3pCyaQX5pUK-m9Vi","edit-icon":"hRkkkB5maZxhaPqpuNJ4g","pointer":"_1mboVIbJQIAQ-24uM9-2Rj"};